import React from "react";
import "./ServiceComponents.css";
import LogoCover from "../assets/images/projectimg/logocover.jpg";
import Brochure from "../assets/images/projectimg/brochure.jpg";
import SMpost from "../assets/images/projectimg/smpost.jpg";

const GraphicDesign = () => {
  const projects = [
    {
      id: 1,
      title: "Logo",
      description:
        "Complete branding package including logo, colors, and typography",
      category: "logo",
      image: LogoCover,
      url: "https://www.behance.net/gallery/232560385/LOGOS",
    },
    {
      id: 2,
      title: "Social media posts",
      description: "Professional Social media posts for Educational Institutes",
      category: "Social Media Posts",
      image: SMpost,
      url: "https://www.behance.net/gallery/232559403/Educational-Institutes-Social-Media-Posts",
    },
    {
      id: 3,
      title: "Marketing Brochures",
      description: "Professional brochure design for corporate marketing",
      category: "Print Design",
      url: "https://www.behance.net/gallery/232561759/Brochure-and-Poster-Design",
      image: Brochure,
    },
  ];

  const handleViewProject = (url) => {
    // Open the URL in a new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="service-component">
      <h2 className="service-title">Graphic Design Projects</h2>
      <p className="service-description">
        Creative visual designs that communicate brand identity and engage
        audiences
      </p>

      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-image">
              {project.image ? (
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-img"
                />
              ) : (
                <div className="image-placeholder design-placeholder">
                  <span className="placeholder-text">{project.title}</span>
                </div>
              )}
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.description}</p>
              <div className="project-category">
                <span className="category-badge">{project.category}</span>
              </div>
              <button
                className="project-btn"
                onClick={() => handleViewProject(project.url)}
                disabled={!project.url} // Disable button if no URL
              >
                {project.url ? "View Project" : "Coming Soon"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GraphicDesign;
